import axios from "axios";
import cogoToast from "cogo-toast";
import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useGlobalContext } from "../context";

export default function Footer({
  setgoalLevel,
  goalLevel,
  setQuesID,
  QuesID,
  singleQuestion,
  setID,
  setMultiLimit,
  MultiLimit,
  setUpdateCheck,
  setData,
  Data,
  id,
  MultiLimitSub,
  setMultiLimitSub,
  QUESTIONS,
  // stuDetails,
  // filteredJSON,
  // setFilter
  initialData,
}) {
  var {
    stuDetails,
    filteredJSON,
    setFilteredJSON,
    setSubmit,
    setUpdate,
    totalQuestions,
    setTotalQuestions,
  } = useGlobalContext();

  const [previousPage, setPreviousPage] = useState(null);

  let [progress, setProgress] = useState("");
  const mathGradeLevelChanged = useRef(false);
  const decodingGradeLevelChanged = useRef(false);
  const readingGradeLevelChanged = useRef(false);
  const { setPercentage, percentage, setStuDetails, setDisable } =
    useGlobalContext();
  const groupNameArray = [
    "Background",
    "Decoding",
    "Reading Comprehension",
    "Math",
    "Speech and Language",
    "Social-emotional",
    "Summary",
  ];
  const uniqueArray = (array) => {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }

    return a;
  };

  const isQuestionUpdate = (id, QuesID) => {
    if (Data[id].questions[QuesID].answered === true) {
      let parent = groupNameArray[id];
      const question = QuesID;
      var oldAnswer = filteredJSON.filter(
        (x) => x.groupName == parent && x.externalId == QuesID
      );
      let currentAnswer = [];
      if (Data[id].questions[QuesID].select == "Accordian") {
        const getSelectedGoals = Data[id].questions[QuesID].goalQues.filter(
          (x) => x.check === true
        );
        for (const goal of getSelectedGoals) {
          const tempObj = {};
          tempObj.value = goal.value;
          tempObj.subAnswers = goal.text
            .filter((x) => x.check === true)
            .map((x) => x.text);
          currentAnswer.push(tempObj);
          // goal.text = goal.text.filter((x) => x.check === true);
        }
      } else {
        currentAnswer = Data[id].questions[QuesID].options
          .filter((x) => x.check === true)
          .map((x) => x.value);
      }
      if (
        oldAnswer &&
        oldAnswer.length &&
        JSON.stringify(oldAnswer[0].answeres) == JSON.stringify(currentAnswer)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const GradeLevels = [
    ["Nursery"],
    ["Kindergarten", "Pre1-A"],
    ["1", 1],
    ["2", 2],
    ["3", 3],
    [4, "4"],
    ["5", 5],
    ["6", 6],
    ["7", 7],
    ["8", 8],
    ["9", 9],
    ["10", 10],
    ["11", 11],
    ["12", 12],
  ];

  const clearSelection = (parent, child) => {
    if (Data[parent].questions[child].select === "Multi") {
      Data[parent].questions[child].answered = false;
      Data[parent].questions[child].limit = false;
      Data[parent].questions[child].options.forEach((el) => (el.check = false));
    } else {
      Data[parent].questions[child].answered = false;
      Data[parent].questions[child].limit = false;
      Data[parent].questions[child].goalQues.forEach((el) => {
        el.check = false;
        el.text.forEach((text) => {
          text.check = false;
        });
      });
    }
  };

  const handleNext = () => {
    const grade = GradeLevels.findIndex((x) => x.includes(stuDetails.Grade));
    const checkUpdate = isQuestionUpdate(id, QuesID);
    changeQuestionToGender(id, QuesID);
    if (id == 0 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        if (checkUpdate === false) {
          var toShowOptions = [];
          Data[id].questions[QuesID].options.forEach((value, index) => {
            if (value.check === true) {
              toShowOptions = toShowOptions.concat(value.show);
            }
          });

          Data[id].questions[QuesID + 2].options.forEach((value, index) => {
            Data[id].questions[QuesID + 2].options[index].check = false;
            if (toShowOptions.includes(index)) {
              Data[id].questions[QuesID + 2].options[index].isHidden = false;
            } else {
              Data[id].questions[QuesID + 2].options[index].isHidden = true;
            }
            setData(Data);
          });
        }

        nextQuestion(id, QuesID);
      }
    }

    if (id == 0 && QuesID == 1) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        setUpdateCheck(-1);
        nextQuestion(id, QuesID);
      }
    }
    if (id == 0 && QuesID == 2) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 0 && QuesID == 3) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 0 && QuesID == 4) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        setUpdateCheck(-1);
        nextQuestion(id, QuesID);
      }
    }
    if (id == 1 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 1 && QuesID == 1) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        if (grade < 0) {
          Data[id].questions[QuesID + 1].options.forEach((value, index) => {
            Data[id].questions[QuesID + 1].options[index].isHidden =
              index !== 0;
          });
        } else {
          Data[id].questions[QuesID + 1].options.forEach((value, index) => {
            if (Data[id].questions[QuesID + 1].options[index].level <= grade) {
              Data[id].questions[QuesID + 1].options[index].isHidden = false;
            } else {
              Data[id].questions[QuesID + 1].options[index].isHidden = true;
            }
          });
          if (grade === 0) {
            Data[id].questions[QuesID + 1].options[0].isHidden = false;
          }
          setData(Data);
        }

        nextQuestion(id, QuesID);
      }
    }
    if (id == 1 && QuesID == 2) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      decodingGradeLevelChanged.current = checkUpdate;
      if (!checkUpdate) {
        const elementToClear = [3, 4, 5, 6];
        elementToClear.forEach((el) => {
          clearSelection(id, el);
        });
        console.log(Data);
      }

      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 1 && QuesID == 3) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 1 && QuesID == 4) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else if (!checkUpdate || !decodingGradeLevelChanged.current) {
        decodingGradeLevelChanged.current = true;
        var option = [];
        var dependentLevel = Data[id].questions[
          Data[id].questions[QuesID + 1].dependQuestion
        ].options.filter((x) => x.check === true);
        const newGrade = grade === 0 ? 1 : grade;
        Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
          if (
            value.level < newGrade + 1 &&
            value.level >= dependentLevel[0].level
          ) {
            var isPresenrt = option.filter((x) => x.value == value.title);
            if (!isPresenrt.length > 0) {
              var subGoals = [];
              value.subGoals.forEach((x) => {
                subGoals.push({
                  text: x,
                  check: false,
                });
              });
              option.push({
                value: value.title,
                text: subGoals,
                check: false,
              });
            } else {
              var superGoalIndex = option.findIndex(
                (p) => p.value == value.title
              );
              value.subGoals.forEach((x) => {
                var exsitdGoal = option[superGoalIndex].text.filter(
                  (goal) => goal.text == x
                );
                if (!exsitdGoal.length > 0) {
                  option[superGoalIndex].text.push({
                    text: x,
                    check: false,
                  });
                }
              });
            }
          }
        });
        Data[id].questions[QuesID + 1].goalQues = option;
        // if (!option.length) {
        //   nextQuestion(id, QuesID + 1);
        //   setPreviousPage({id, quesID: QuesID});
        // } else {
        // }
      }
      nextQuestion(id, QuesID);
      setData(Data);
    }
    if (id == 1 && QuesID == 5) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      //to check subgoal limit
      let allsublimit = allCheckded.map((x) => x.text);
      let countTrue = 0;
      for (let array of allsublimit) {
        if (array.length >= 1) {
          let trueCount = 0;
          for (let obj of array) {
            if (obj.check) {
              trueCount++;
            }
          }
          if (trueCount >= 1) {
            countTrue++;
          }
        }
      }
      const length = allsublimit.filter((array) => array.length >= 1).length;
      if (countTrue === length) {
        var option = [];

        if (allCheckded.length < 1) {
          cogoToast.error("Minimum 1 selection is required");
        } else if (!checkUpdate) {
          var allAnsers = [];
          allCheckded.forEach((value, index) => {
            value.text.forEach((texval, point) => {
              if (texval.check === true) allAnsers.push(texval.text);
            });
          });
          var dependentLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);
          Data[id].questions[QuesID + 1].suberGoals.forEach(
            (value, index) => {
              if (
                value.level <= grade  &&
                value.level >= dependentLevel[0].level
              ) {
                var isPresenrt = option.filter((x) => x.value == value.title);
                if (!isPresenrt.length > 0) {
                  var subGoals = [];
                  value.subGoals.forEach((x) => {
                    var exsitdGoal = subGoals.filter(
                      (goal) => goal.text == x
                    );
                    if (!exsitdGoal.length > 0) {
                      if (!allAnsers.includes(x)) {
                        subGoals.push({
                          text: x,
                          check: false,
                        });
                      }
                    }
                  });
                  option.push({
                    value: value.title,
                    text: subGoals,
                    check: false,
                  });
                } else {
                  var superGoalIndex = option.findIndex(
                    (p) => p.value == value.title
                  );
                  value.subGoals.forEach((x) => {
                    var exsitdGoal = option[superGoalIndex].text.filter(
                      (goal) => goal.text == x
                    );
                    if (!exsitdGoal.length > 0) {
                      if (!allAnsers.includes(x)) {
                        option[superGoalIndex].text.push({
                          text: x,
                          check: false,
                        });
                      }
                    }
                  });
                }
              }
            }
          );
          Data[id].questions[QuesID + 1].limit = false;
          Data[id].questions[QuesID + 1].goalQues = option.filter(
            (el) => !!el.text.length
          );
          if (allCheckded.length) {
            if (
              (option.length === 1 && !option[0].text.length) ||
              !option.length
            ) {
              nextQuestion(id, Data[id].questions.length - 1);
              Data[id].questions[QuesID + 1].answered = false;
            } else {
              nextQuestion(id, QuesID);
            }
          }
        } else {
          nextQuestion(id, QuesID);
        }

        setData(Data);
      } else {
        cogoToast.error("Select at least 1 goal from each smart goal.");
      }
    }
    if (id == 1 && QuesID == 6) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );

      const allOptions = Data[id].questions[QuesID].goalQues.reduce(
        (prev, curr) => {
          return [...prev, ...curr.text.map((el) => el)];
        },
        []
      );

      if (allOptions.length < 3) {
        var allsubChecked = 0;
        allCheckded.forEach((value, index) => {
          value.text.forEach((textval, textindex) => {
            if (textval.check === true) allsubChecked += 1;
          });
        });
        if (allsubChecked !== allOptions.length) {
          cogoToast.error(`${allOptions.length} required.`);
        } else {
          nextQuestion(id, QuesID);
        }
      } else {
        var allsubChecked = 0;
        allCheckded.forEach((value, index) => {
          value.text.forEach((textval, textindex) => {
            if (textval.check === true) allsubChecked += 1;
          });
        });
        if (allsubChecked < 3) {
          cogoToast.error("Minimum 3 subgoals required.");
        } else {
          nextQuestion(id, QuesID);
        }
      }
      setData(Data);
    }
    if (id == 2 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 2 && QuesID == 1) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        if (checkUpdate === false) {
          Data[id].questions[QuesID + 1].options.forEach((value, index) => {
            if (Data[id].questions[QuesID + 1].options[index].level <= grade) {
              Data[id].questions[QuesID + 1].options[index].isHidden = false;
              setData(Data);
            } else {
              Data[id].questions[QuesID + 1].options[index].isHidden = true;
              setData(Data);
            }
          });
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 2 && QuesID == 2) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      readingGradeLevelChanged.current = checkUpdate;
      if (!checkUpdate) {
        const elementToClear = [3, 4, 5, 6];
        elementToClear.forEach((el) => {
          clearSelection(id, el);
        });
        console.log(Data);
      }
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 2 && QuesID == 3) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 2 && QuesID == 4) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        if (checkUpdate === false || !readingGradeLevelChanged.current) {
          readingGradeLevelChanged.current = true;
          console.log(readingGradeLevelChanged.current);
          var option = [];
          var dependentLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);
          const newGrade = grade === 0 ? 1 : grade;

          Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
            if (
              value.level < newGrade + 1 &&
              value.level >= dependentLevel[0].level
            ) {
              var isPresenrt = option.filter((x) => x.value == value.title);
              if (!isPresenrt.length > 0) {
                var subGoals = [];
                value.subGoals.forEach((x) => {
                  subGoals.push({
                    text: x,
                    check: false,
                  });
                });
                option.push({
                  value: value.title,
                  text: subGoals,
                  check: false,
                });
              } else {
                var superGoalIndex = option.findIndex(
                  (p) => p.value == value.title
                );
                value.subGoals.forEach((x) => {
                  var exsitdGoal = option[superGoalIndex].text.filter(
                    (goal) => goal.text == x
                  );
                  if (!exsitdGoal.length > 0) {
                    option[superGoalIndex].text.push({
                      text: x,
                      check: false,
                    });
                  }
                });
              }
            }
          });
          Data[id].questions[QuesID + 1].goalQues = option;
          setData(Data);
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 2 && QuesID == 5) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      //to check subgoal limit
      let allsublimit = allCheckded.map((x) => x.text);
      let countTrue = 0;
      for (let array of allsublimit) {
        if (array.length >= 1) {
          let trueCount = 0;
          for (let obj of array) {
            if (obj.check) {
              trueCount++;
            }
          }
          if (trueCount >= 1) {
            countTrue++;
          }
        }
      }
      if (
        countTrue === allsublimit.filter((array) => array.length >= 1).length
      ) {
        if (allCheckded.length < 1) {
          cogoToast.error("At least main smart goal required");
        } else {
          if (checkUpdate === false) {
            var allAnsers = [];
            allCheckded.forEach((value, index) => {
              value.text.forEach((texval, point) => {
                if (texval.check === true) allAnsers.push(texval.text);
              });
            });
            var option = [];
            Data[id].questions[QuesID + 1].limit = false;
            var dependentLevel = Data[id].questions[
              Data[id].questions[QuesID + 1].dependQuestion
            ].options.filter((x) => x.check === true);
            Data[id].questions[QuesID + 1].suberGoals.forEach(
              (value, index) => {
                if (
                  value.level <= grade + 1 &&
                  value.level >= dependentLevel[0].level
                ) {
                  var isPresenrt = option.filter((x) => x.value == value.title);
                  if (!isPresenrt.length > 0) {
                    var subGoals = [];
                    value.subGoals.forEach((x) => {
                      var exsitdGoal = subGoals.filter(
                        (goal) => goal.text == x
                      );
                      if (!exsitdGoal.length > 0) {
                        if (!allAnsers.includes(x)) {
                          subGoals.push({
                            text: x,
                            check: false,
                          });
                        }
                      }
                    });
                    option.push({
                      value: value.title,
                      text: subGoals,
                      check: false,
                    });
                  } else {
                    var superGoalIndex = option.findIndex(
                      (p) => p.value == value.title
                    );
                    value.subGoals.forEach((x) => {
                      var exsitdGoal = option[superGoalIndex].text.filter(
                        (goal) => goal.text == x
                      );
                      if (!exsitdGoal.length > 0) {
                        if (!allAnsers.includes(x)) {
                          option[superGoalIndex].text.push({
                            text: x,
                            check: false,
                          });
                        }
                      }
                    });
                  }
                }
              }
            );
            Data[id].questions[QuesID + 1].goalQues = option;
            setData(Data);
          }
          nextQuestion(id, QuesID);
        }
      } else {
        cogoToast.error("Select at least 1 goal from each smart goal.");
      }
    }
    if (id == 2 && QuesID == 6) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      //to check subgoal limit
      let allsublimit = allCheckded.map((x) => x.text);
      let countTrue = 0;
      for (let array of allsublimit) {
        if (array.length >= 1) {
          let trueCount = 0;
          for (let obj of array) {
            if (obj.check) {
              trueCount++;
            }
          }
          if (trueCount >= 1) {
            countTrue++;
          }
        }
      }
      if (
        countTrue === allsublimit.filter((array) => array.length >= 1).length
      ) {
        if (allCheckded.length < 1) {
          cogoToast.error("At least 1 smart goal required.");
        } else {
          nextQuestion(id, QuesID);
        }
      } else {
        cogoToast.error("Select at least 1 goal from each smart goal.");
      }
    }
    if (id == 3 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        if (checkUpdate === false) {
          Data[id].questions[QuesID + 1].options.forEach((value, index) => {
            if (Data[id].questions[QuesID + 1].options[index].level <= grade) {
              Data[id].questions[QuesID + 1].options[index].isHidden = false;
              setData(Data);
            } else {
              Data[id].questions[QuesID + 1].options[index].isHidden = true;
              setData(Data);
            }
          });
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 3 && QuesID == 1) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      mathGradeLevelChanged.current = checkUpdate;
      if (!checkUpdate) {
        const elementToClear = [2, 3, 4, 5];
        elementToClear.forEach((el) => {
          clearSelection(id, el);
        });
      }
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 3 && QuesID == 2) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 3 && QuesID == 3) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked < 1) {
        cogoToast.error(`Required`);
      } else {
        if (checkUpdate === false || !mathGradeLevelChanged.current) {
          mathGradeLevelChanged.current = true;
          var option = [];
          var dependentLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);
          Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
            if (
              value.level < grade + 1 &&
              value.level >= dependentLevel[0].level
            ) {
              var isPresenrt = option.filter((x) => x.value == value.title);
              if (!isPresenrt.length > 0) {
                var subGoals = [];
                value.subGoals.forEach((x) => {
                  subGoals.push({
                    text: x,
                    check: false,
                  });
                });
                option.push({
                  value: value.title,
                  text: subGoals,
                  check: false,
                });
              } else {
                var superGoalIndex = option.findIndex(
                  (p) => p.value == value.title
                );
                value.subGoals.forEach((x) => {
                  var exsitdGoal = option[superGoalIndex].text.filter(
                    (goal) => goal.text == x
                  );
                  if (!exsitdGoal.length > 0) {
                    option[superGoalIndex].text.push({
                      text: x,
                      check: false,
                    });
                  }
                });
              }
            }
          });
          Data[id].questions[QuesID + 1].goalQues = option;
          setData(Data);
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 3 && QuesID == 4) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      if (allCheckded.length < 3) {
        cogoToast.error("3 smart goals required");
      } else {
        if (checkUpdate === false) {
          Data[id].questions[QuesID + 1].limit = false;
          var allAnsers = [];
          allCheckded.forEach((value, index) => {
            value.text.forEach((texval, point) => {
              if (texval.check === true) allAnsers.push(texval.text);
            });
          });
          var option = [];
          var dependentLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);
          Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
            var checkInHide = Data[id].questions[
              QuesID + 1
            ].removeSuperGoals.filter((x) => x.hide == value.title);
            var toAdd = true;
            if (checkInHide.length > 0) {
              allAnsers.every((x) => {
                if (checkInHide[0].titles.includes(x)) {
                  toAdd = false;
                  return false;
                }
                return true;
              });
            }
            if (
              value.level <= grade + 1 &&
              value.level >= dependentLevel[0].level &&
              toAdd
            ) {
              var isPresenrt = option.filter((x) => x.value == value.title);
              if (!isPresenrt.length > 0) {
                var subGoals = [];
                value.subGoals.forEach((x) => {
                  var exsitdGoal = subGoals.filter((goal) => goal.text == x);
                  if (!exsitdGoal.length > 0) {
                    if (!allAnsers.includes(x)) {
                      subGoals.push({
                        text: x,
                        check: false,
                      });
                    }
                  }
                });
                option.push({
                  value: value.title,
                  text: subGoals,
                  check: false,
                });
              } else {
                var superGoalIndex = option.findIndex(
                  (p) => p.value == value.title
                );
                value.subGoals.forEach((x) => {
                  var exsitdGoal = option[superGoalIndex].text.filter(
                    (goal) => goal.text == x
                  );
                  if (!exsitdGoal.length > 0) {
                    if (!allAnsers.includes(x)) {
                      option[superGoalIndex].text.push({
                        text: x,
                        check: false,
                      });
                    }
                  }
                });
              }
            }
          });

          option = option.filter((x) => x.text.length > 0);

          Data[id].questions[QuesID + 1].goalQues = option;
          setData(Data);
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 3 && QuesID == 5) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      if (allCheckded.length < 3) {
        cogoToast.error("3 smart goals required");
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 4 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        console.log(checkUpdate);
        if (checkUpdate === false) {
          const indexesToClear = [1, 2, 3, 4, 5, 6];
          indexesToClear.forEach((el) => {
            clearSelection(id, el);
          });
          setData(Data);
        }

        if (allChecked[0].value == "Yes") {
          Data[id].questions[QuesID].answered = true;
          setPreviousPage({
            from: [id, QuesID],
            to: [id, QuesID + 2],
          });
          nextQuestion(id, QuesID + 1, false);
        } else {
          nextQuestion(id, QuesID);
        }
      }
    }
    if (id == 4 && QuesID == 1) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );

      const previousQuestionSelected = Data[id].questions[
        QuesID - 1
      ].options.filter((el) => el.check);
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        if (
          allChecked[0].value === "No" &&
          previousQuestionSelected[0].value !== "Yes"
        ) {
          nextQuestion(id, QuesID);
          nextQuestion(id, Data[id].questions.length - 1, false);

          setData(Data);
          setPreviousPage({ id, quesID: QuesID });
        } else if (
          allChecked[0].value === "Yes" &&
          previousQuestionSelected[0].value !== "Yes"
        ) {
          nextQuestion(id, QuesID);
          nextQuestion(id, QuesID + 1, false);
          setPreviousPage({
            from: [id, QuesID],
            to: [id, QuesID + 1],
          });
        } else {
          nextQuestion(id, QuesID);
        }
      }
    }
    if (id == 4 && QuesID == 2) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 4 && QuesID == 3) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        if (checkUpdate === false) {
          var toHideOptions = [];
          allChecked.forEach((value, index) => {
            toHideOptions = toHideOptions.concat(value.doHide);
          });
          Data[id].questions[QuesID + 1].options.forEach((value, index) => {
            Data[id].questions[QuesID + 1].options[index].check = false;
            if (toHideOptions.includes(index)) {
              Data[id].questions[QuesID + 1].options[index].isHidden = true;
            } else {
              Data[id].questions[QuesID + 1].options[index].isHidden = false;
            }
            setData(Data);
          });
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 4 && QuesID == 4) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 4 && QuesID == 5) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        if (checkUpdate === false) {
          Data[id].questions[QuesID + 1].limit = false;
          var toHideOptions = [];
          allChecked.forEach((value, index) => {
            toHideOptions = toHideOptions.concat(value.doHide);
          });
          Data[id].questions[QuesID + 1].options.forEach((value, index) => {
            Data[id].questions[QuesID + 1].options[index].check = false;
            if (toHideOptions.includes(index)) {
              Data[id].questions[QuesID + 1].options[index].isHidden = true;
            } else {
              Data[id].questions[QuesID + 1].options[index].isHidden = false;
            }
            setData(Data);
          });
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 4 && QuesID == 6) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 5 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < Data[id].questions[QuesID].min) {
        cogoToast.error(`Minimum ${Data[id].questions[QuesID].min} Required`);
      } else {
        if (allChecked.length == 1 && allChecked[0].value == "none") {
          nextQuestion(id, Data[id].questions.length - 1);
          Data[id].questions[1].answered = false;
          Data[id].questions[2].answered = false;
          Data[id].questions[3].answered = false;
          Data[id].questions[4].answered = false;
          setData(Data);
        } else {
          // if (checkUpdate === false) {
          var option = [];
          var checkedLevel = Data[id].questions[
            Data[id].questions[QuesID + 2].dependQuestion
          ].options.filter((x) => x.check === true);

          var DependentLevel = [];
          checkedLevel.forEach((value, index) => {
            if (value.check === true) DependentLevel.push(value.level);
          });

          Data[id].questions[QuesID + 2].suberGoals.forEach((value, index) => {
            if (DependentLevel.includes(value.level)) {
              var subGoals = [];
              value.subGoals.forEach((x) => {
                subGoals.push({
                  text: x,
                  check: false,
                });
              });
              option.push({
                value: value.title,
                text: subGoals,
                check: false,
              });
            }
          });

          Data[id].questions[QuesID + 2].goalQues = option;
          setData(Data);
          // }
          nextQuestion(id, QuesID);
        }
      }
    }
    if (id == 5 && QuesID == 1) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );
      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else {
        if (checkUpdate === false) {
          var option = [];
          var checkedLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);
          Data[id].questions[2].answered = false;
          Data[id].questions[3].answered = false;
          Data[id].questions[4].answered = false;
          var DependentLevel = [];
          checkedLevel.forEach((value, index) => {
            if (value.check === true) DependentLevel.push(value.level);
          });

          Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
            if (DependentLevel.includes(value.level)) {
              var subGoals = [];
              value.subGoals.forEach((x) => {
                subGoals.push({
                  text: x,
                  check: false,
                });
              });
              option.push({
                value: value.title,
                text: subGoals,
                check: false,
              });
            }
          });

          Data[id].questions[QuesID + 1].goalQues = option;
          setData(Data);
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 5 && QuesID == 2) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      if (allCheckded.length < Data[id].questions[QuesID].goalQues.length) {
        cogoToast.error("1 answer for each section is required");
      } else {
        if (checkUpdate === false) {
          var option = [];
          Data[id].questions[QuesID + 1].limit = false;
          Data[id].questions[QuesID + 1].answered = false;
          var checkedLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);

          var DependentLevel = [];
          checkedLevel.forEach((value, index) => {
            if (value.check === true) DependentLevel.push(value.level);
          });

          Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
            if (DependentLevel.includes(value.level)) {
              var subGoals = [];
              value.subGoals.forEach((x) => {
                subGoals.push({
                  text: x,
                  check: false,
                });
              });
              option.push({
                value: value.title,
                text: subGoals,
                check: false,
              });
            }
          });

          Data[id].questions[QuesID + 1].goalQues = option;
          setData(Data);
        }
        nextQuestion(id, QuesID);
      }
    }
    if (id == 5 && QuesID == 3) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );

      if (allCheckded.length < Data[id].questions[QuesID].goalQues.length) {
        cogoToast.error("1 answer for each section is required");
      } else {
        if (checkUpdate === false) {
          var allCheckded = Data[id].questions[QuesID].goalQues.filter(
            (x) => x.check === true
          );
          Data[id].questions[QuesID + 1].answered = false;
          var option = [];
          var checkedLevel = Data[id].questions[
            Data[id].questions[QuesID + 1].dependQuestion
          ].options.filter((x) => x.check === true);

          var DependentLevel = [];
          var allanswer = [];
          allCheckded.forEach((value, index) => {
            value.text.forEach((val, point) => {
              if (val.check === true) allanswer.push(val.text);
            });
            //if (value.check === true) DependentLevel.push(value.level);
          });

          checkedLevel.forEach((value, index) => {
            if (value.check === true) DependentLevel.push(value.level);
          });

          Data[id].questions[QuesID + 1].suberGoals.forEach((value, index) => {
            if (DependentLevel.includes(value.level)) {
              var subGoals = [];
              value.subGoals.forEach((x) => {
                if (x.hideIf.length > 0) {
                  if (!allanswer.includes(x.hideIf[0])) {
                    subGoals.push({
                      text: x.title,
                      check: false,
                    });
                  }
                } else {
                  subGoals.push({
                    text: x.title,
                    check: false,
                  });
                }
              });
              option.push({
                value: value.title,
                text: subGoals,
                check: false,
              });
            }
          });

          Data[id].questions[QuesID + 1].goalQues = option;

          setData(Data);
        }

        nextQuestion(id, QuesID);
      }
    }
    if (id == 5 && QuesID == 4) {
      var allCheckded = Data[id].questions[QuesID].goalQues.filter(
        (x) => x.check === true
      );
      const allsubChecked = [];
      allCheckded.forEach((el) => {
        const subchecked = el.text.filter((sub) => sub.check);
        allsubChecked.push(subchecked);
      });

      const found = allsubChecked.find((el) => el.length < 2);
      if (found || !allCheckded.length) {
        cogoToast.error(`Select minimum 2 answers on each section`);
      } else {
        nextQuestion(id, QuesID);
      }
    }
    if (id == 6 && QuesID == 0) {
      var allChecked = Data[id].questions[QuesID].options.filter(
        (x) => x.check === true
      );

      const SECTION_TO_SKIP = [4, 5, 6];
      const unanswered = Data.reduce((prev, curr, index) => {
        if (SECTION_TO_SKIP.includes(index)) {
          return prev;
        } else {
          const elements = curr.questions.filter((el) => !el.answered);
          return [...prev, ...elements];
        }
      }, []);

      console.log("u", unanswered);

      if (allChecked.length < 1) {
        cogoToast.error(`Required`);
      } else if (unanswered.length) {
        cogoToast.error(`Answer all questions`);
      } else {
        Data[id].questions[QuesID].answered = true;
        setData(Data);
        PostData(id, QuesID);
      }
    }
  };

  useEffect(() => {
    const percentage = (id / 6) * 100;
    setPercentage(percentage);

    if (id === 1) {
      setProgress("w-1/6");
    } else if (id === 2) {
      setProgress("w-2/6");
    } else if (id === 3) {
      setProgress("w-3/6");
    } else if (id === 4) {
      setProgress("w-4/6");
    } else if (id === 5) {
      setProgress("w-5/6");
    } else if (id === 6) {
      setProgress("w-full");
    } else {
      setProgress("");
    }
  }, [percentage, filteredJSON, id]);

  const nextQuestion = (parent, question, makeTrue = true) => {
    if (makeTrue) Data[parent].questions[question].answered = true;
    setData(Data);
    var questionLength = Data[parent].questions.length;
    var parentId = parent;
    var questionId = question;
    // if(totalQuestions.length){
    if (question < questionLength - 1) {
      questionId = questionId + 1;
    } else {
      questionId = 0;
      parentId = parentId + 1;
    }

    // }else{
    //   questionId = 0;
    //     parentId = parentId
    // }
    if (
      "isRandom" in Data[parentId].questions[questionId] &&
      Data[parentId].questions[questionId].isRandom === true
    ) {
      questionId = questionId + 1;
    }

    PostData(parentId, questionId);
    setID(parentId);
    setQuesID(questionId);

    const percentage = (id / 6) * 100;
    setPercentage(percentage);

    if (id === 1) {
      setProgress("w-1/6");
    } else if (id === 2) {
      setProgress("w-2/6");
    } else if (id === 3) {
      setProgress("w-3/6");
    } else if (id === 4) {
      setProgress("w-4/6");
    } else if (id === 5) {
      setProgress("w-5/6");
    } else if (id === 6) {
      setProgress("w-full");
    }

    // scroll to top func

    if (window) {
      window.scroll(0, 0);
    }
  };

  const getFilteredJSONData = (groupId, questionId) => {
    const groupName = groupNameArray[groupId];
    let filteredJSONQuestionObj = { groupName: groupName };
    const getGroupObjFromParent = Data.find(
      (x) => x.title.toLowerCase() === groupName.toLowerCase()
    );
    const getCompletedQuestionFromGroup =
      getGroupObjFromParent.questions[questionId];

    const is_exist = filteredJSON.filter(
      (x) => x.groupName == groupName && x.externalId == questionId
    );

    if (is_exist.length > 0) {
      const index = filteredJSON.findIndex(
        (x) => x.groupName == groupName && x.externalId == questionId
      );
      if (getCompletedQuestionFromGroup.select === "Accordian") {
        const getSelectedGoals = getCompletedQuestionFromGroup.goalQues.filter(
          (x) => x.check === true
        );
        filteredJSON[index].answeres = [];
        for (const goal of getSelectedGoals) {
          const tempObj = {};
          tempObj.value = goal.value;
          tempObj.subAnswers = goal.text
            .filter((x) => x.check === true)
            .map((x) => x.text);
          filteredJSON[index].answeres.push(tempObj);
          // goal.text = goal.text.filter((x) => x.check === true);
        }
      } else {
        filteredJSON[index].answeres = getCompletedQuestionFromGroup.options
          .filter((x) => x.check === true)
          .map((x) => x.value);
      }
    } else {
      filteredJSONQuestionObj.questionId =
        getCompletedQuestionFromGroup.questionID;
      filteredJSONQuestionObj.externalId = QuesID;
      filteredJSONQuestionObj.groupID = groupId;
      filteredJSONQuestionObj.question = getCompletedQuestionFromGroup.question;

      if (getCompletedQuestionFromGroup.select === "Accordian") {
        filteredJSONQuestionObj.question =
          filteredJSONQuestionObj.question.replace(
            "name",
            stuDetails.FirstName
          );

        const getSelectedGoals = getCompletedQuestionFromGroup.goalQues.filter(
          (x) => x.check === true
        );
        filteredJSONQuestionObj.answeres = [];
        for (const goal of getSelectedGoals) {
          const tempObj = {};
          tempObj.value = goal.value;
          tempObj.subAnswers = goal.text
            .filter((x) => x.check === true)
            .map((x) => x.text);
          filteredJSONQuestionObj.answeres.push(tempObj);
          // goal.text = goal.text.filter((x) => x.check === true);
        }
      } else {
        filteredJSONQuestionObj.answeres = getCompletedQuestionFromGroup.options
          .filter((x) => x.check === true)
          .map((x) => x.value);
        filteredJSONQuestionObj.question =
          filteredJSONQuestionObj.question.replace(
            "name",
            stuDetails.FirstName
          );

        console.log(filteredJSONQuestionObj.question);
      }

      // setFilter(filteredJSON.concat(filteredJSONQuestionObj));
      filteredJSON.push(filteredJSONQuestionObj);
      setFilteredJSON(filteredJSON);
    }
  };

  const PostData = (parent, ques) => {
    var studentGender = stuDetails.Gender;
    getFilteredJSONData(id, QuesID);
    if (filteredJSON.length) {
      const searchParams = new URLSearchParams(document.location.search);
      const updatedData = filteredJSON;
      let body = JSON.stringify({
        ...stuDetails,
        questions: updatedData,
      });

      body = JSON.parse(body);

      //replacing gender pronouns

      if (studentGender.toLowerCase() === "male") {
        body.questions.forEach((question, index) => {
          question.answeres.forEach((answer, answerIndex) => {
            if (answer.subAnswers) {
              answer.subAnswers.forEach((subAnswer, subAnswerIndex) => {
                if (subAnswer.includes("P1")) {
                  body.questions[index].answeres[answerIndex].subAnswers[
                    subAnswerIndex
                  ] = subAnswer.replace("P1", "he");
                }
                if (subAnswer.includes("P2")) {
                  body.questions[index].answeres[answerIndex].subAnswers[
                    subAnswerIndex
                  ] = subAnswer.replace("P2", "him");
                }
                if (subAnswer.includes("P3")) {
                  body.questions[index].answeres[answerIndex].subAnswers[
                    subAnswerIndex
                  ] = subAnswer.replace("P3", "his");
                }
              });
            }
          });
        });
      } else {
        body.questions.forEach((question, index) => {
          question.answeres.forEach((answer, answerIndex) => {
            if (answer.subAnswers) {
              answer.subAnswers.forEach((subAnswer, subAnswerIndex) => {
                if (subAnswer.includes("P1")) {
                  body.questions[index].answeres[answerIndex].subAnswers[
                    subAnswerIndex
                  ] = subAnswer.replace("P1", "she");
                }
                if (subAnswer.includes("P2")) {
                  body.questions[index].answeres[answerIndex].subAnswers[
                    subAnswerIndex
                  ] = subAnswer.replace("P2", "her");
                }
                if (subAnswer.includes("P3")) {
                  body.questions[index].answeres[answerIndex].subAnswers[
                    subAnswerIndex
                  ] = subAnswer.replace("P3", "her");
                }
              });
            }
          });
        });
      }
      body = JSON.stringify(body);
      var config = {
        method: "POST",
        maxBodyLength: Infinity,
        url: `https://31zctjiomj.execute-api.us-east-1.amazonaws.com/default/enhacereport?StudentID=${searchParams.get(
          "StudentID"
        )}&Token=${searchParams.get("Token")}`,
        headers: {
          "Content-Type": "application/json",

          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,OPTIONS",
          "Access-Control-Allow-Headers":
            "Content-Type, Authorization, Content-Length, X-Requested-With, Accept",
        },
        withCredentials: false,
        crossdomain: true,
        data: body,
      };
      var confighook = {
        method: "POST",
        maxBodyLength: Infinity,
        url: `https://eo1uo5aa7h7sqbm.progressreportapi.enhancedservices.org`,
        data: body,
      };

      axios(config)
        .then(function (response) {
          setTotalQuestions(response.data.questions);
          if (id === 6 && QuesID === 0) {
            axios(confighook);
            setSubmit(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const handleBack = () => {
    // console.log(Data, "<---DATA in back")
    if (window) {
      window.scroll(0, 0);
    }
    const back = true;
    // if (filteredJSON.length) {
    //   const groupName = groupNameArray[id];
    //   const getIdxFromFilteredJSon = filteredJSON.findIndex(x => x.groupName.toLowerCase() === groupName.toLowerCase() && QuesID === x.questionId);
    //   filteredJSON.splice(getIdxFromFilteredJSon, 1);

    //   const searchParams = new URLSearchParams(document.location.search)
    //   console.log('filteredJSON', filteredJSON)
    //   const updatedData = filteredJSON;
    //   const body = JSON.stringify({
    //     ...stuDetails,
    //     "questions": updatedData
    //   });

    //   var config = {
    //     method: 'POST',
    //     maxBodyLength: Infinity,
    //     url: `https://31zctjiomj.execute-api.us-east-1.amazonaws.com/default/enhacereport?StudentID=${searchParams.get('StudentID')}&Token=${searchParams.get('Token')}`,
    //     headers: {
    //       'Content-Type': 'application/json',

    //             "Access-Control-Allow-Origin": "*",
    //             "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,OPTIONS",
    //             "Access-Control-Allow-Headers": "Content-Type, Authorization, Content-Length, X-Requested-With, Accept"

    //     },
    //     withCredentials: false,
    //     crossdomain: true,
    //     data : body
    //   };

    //   axios(config)
    //   .then(function (response) {

    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
    // }

    if (id === 2 && QuesID === 0) {
      const previousQuestion = Data[1].questions[6];
      if (!previousQuestion.options) {
        PreviousQues(2, 6);
      }
    }

    if (id === 4 && QuesID === 2) {
      var allChecked = Data[id].questions[0].options.filter(
        (x) => x.check === true
      );

      if (allChecked[0].value === "Yes") {
        PreviousQues(id, QuesID - 1);
      } else {
        PreviousQues(id, QuesID);
      }
    } else if (id === 4 && QuesID === 3) {
      const first = Data[4].questions[0].options.filter(
        (x) => x.check === true
      );
      const second = Data[4].questions[1].options.filter(
        (x) => x.check === true
      );

      if (first[0].value !== "Yes" && second[0].value === "Yes") {
        PreviousQues(id, 2);
      } else {
        PreviousQues(id, QuesID);
      }
    } else if (id === 5 && QuesID === 0) {
      const first = Data[4].questions[0].options.filter(
        (x) => x.check === true
      );
      const second = Data[4].questions[1].options.filter(
        (x) => x.check === true
      );

      if (first[0].value !== "Yes" && second[0].value === "No") {
        PreviousQues(4, 2);
      } else {
        PreviousQues(id, QuesID);
      }
    } else {
      PreviousQues(id, QuesID);
    }

    // if (previousPage) {
    //   const {from, to} = previousPage;
    //   if (to[0] === id && to[1] === QuesID) {
    //     PreviousQues(from[0], from[1] + 1);
    //     console.log('ik');
    //   } else {
    //     PreviousQues(id, QuesID);
    //   }
    //   setPreviousPage(null);
    //   console.log(previousPage)
    //   // PreviousQues(previousPage.id, previousPage.quesID + 1);
    //   // setPreviousPage({});
    // }
    setData(Data);
  };

  const changeQuestionToGender = (parent, question) => {
    var studentName = stuDetails.FirstName;
    var studentGender = stuDetails.Gender;
    Data[parent].questions[question].question = Data[parent].questions[
      question
    ].question.replace("name", `${studentName}`);

    //convering gender in questions
    if (studentGender.toLowerCase() === "male") {
      Data[parent].questions[question].question = Data[parent].questions[
        question
      ].question.replace("P1", "he");
      Data[parent].questions[question].question = Data[parent].questions[
        question
      ].question.replace("P2", "him");
      Data[parent].questions[question].question = Data[parent].questions[
        question
      ].question.replace("P3", "his");
    } else {
      Data[parent].questions[question].question = Data[parent].questions[
        question
      ].question.replace("P1", "she");
      Data[parent].questions[question].question = Data[parent].questions[
        question
      ].question.replace("P2", "her");
      Data[parent].questions[question].question = Data[parent].questions[
        question
      ].question.replace("P3", "her");
    }
    if (Data[parent].questions[question].select != "Accordian") {
      Data[parent].questions[question].options.forEach((val, index) => {
        console.log("d", Data[parent].questions[question].options[index]);
        Data[parent].questions[question].options[index].value =
          val.value.replace("name", `${studentName}`);
      });

      if (studentGender.toLowerCase() === "male") {
        Data[parent].questions[question].options.forEach((val, index) => {
          Data[parent].questions[question].options[index].value =
            val.value.replace("P1", "he");
        });
        Data[parent].questions[question].options.forEach((val, index) => {
          Data[parent].questions[question].options[index].value =
            val.value.replace("P2", "him");
        });
        Data[parent].questions[question].options.forEach((val, index) => {
          Data[parent].questions[question].options[index].value =
            val.value.replace("P3", "his");
        });
      } else {
        Data[parent].questions[question].options.forEach((val, index) => {
          Data[parent].questions[question].options[index].value =
            val.value.replace("P1", "she");
        });
        Data[parent].questions[question].options.forEach((val, index) => {
          Data[parent].questions[question].options[index].value =
            val.value.replace("P2", "her");
        });
        Data[parent].questions[question].options.forEach((val, index) => {
          Data[parent].questions[question].options[index].value =
            val.value.replace("P3", "her");
        });
      }
    } else {
      if (studentGender.toLowerCase() === "male") {
        Data[parent].questions[question].suberGoals.forEach((val, index) => {
          Data[parent].questions[question].suberGoals[index].subGoals.forEach(
            (innserVal, i) => {
              if (
                typeof Data[parent].questions[question].suberGoals[index]
                  .subGoals[i] === "object"
              ) {
                console.log(
                  Data[parent].questions[question].suberGoals[index].subGoals[i]
                    .title,
                  "<TITLE"
                );
                Data[parent].questions[question].suberGoals[index].subGoals[
                  i
                ].title = Data[parent].questions[question].suberGoals[
                  index
                ].subGoals[i].title.replace("P1", "he");
                Data[parent].questions[question].suberGoals[index].subGoals[
                  i
                ].title = Data[parent].questions[question].suberGoals[
                  index
                ].subGoals[i].title.replace("P2", "him");
                Data[parent].questions[question].suberGoals[index].subGoals[
                  i
                ].title = Data[parent].questions[question].suberGoals[
                  index
                ].subGoals[i].title.replace("P3", "his");
              } else {
                console.log("<-------->");
                Data[parent].questions[question].suberGoals[index].subGoals[i] =
                  Data[parent].questions[question].suberGoals[index].subGoals[
                    i
                  ].replace("P1", "he");
                Data[parent].questions[question].suberGoals[index].subGoals[i] =
                  Data[parent].questions[question].suberGoals[index].subGoals[
                    i
                  ].replace("P2", "him");
                Data[parent].questions[question].suberGoals[index].subGoals[i] =
                  Data[parent].questions[question].suberGoals[index].subGoals[
                    i
                  ].replace("P3", "his");
              }
            }
          );
        });
      } else {
        Data[parent].questions[question].suberGoals.forEach((val, index) => {
          Data[parent].questions[question].suberGoals[index].subGoals.forEach(
            (innserVal, i) => {
              if (
                typeof Data[parent].questions[question].suberGoals[index]
                  .subGoals[i] === "object"
              ) {
                Data[parent].questions[question].suberGoals[index].subGoals[
                  i
                ].title = innserVal.title.replace("P1", "she");
                Data[parent].questions[question].suberGoals[index].subGoals[
                  i
                ].title = innserVal.title.replace("P2", "her");
                Data[parent].questions[question].suberGoals[index].subGoals[
                  i
                ].title = innserVal.title.replace("P3", "her");
              } else {
                Data[parent].questions[question].suberGoals[index].subGoals[i] =
                  innserVal.replace("P1", "she");
                // Data[parent].questions[question].suberGoals[index].subGoals[i] = innserVal.replace("P2", "her")
                // Data[parent].questions[question].suberGoals[index].subGoals[i] = innserVal.replace("P3", "her")
              }
            }
          );
        });
      }
    }
    setData(Data);
  };

  const PreviousQues = (parent, question) => {
    // if (Data[parent].questions[question].answered) {
    //   console.log('aaa')
    //   Data[parent].questions[question].answered = false;
    //   if(Data[parent].questions[question].select == "Accordian"){
    //     Data[parent].questions[question].goalQues = [];

    //   }else{
    //     for (const answer of Data[parent].questions[question].options) {
    //       if (answer.check) {
    //         answer.check = false;
    //       }
    //     }
    //   }

    // }

    if (question == 0) {
      parent = parent - 1;
      question = Data[parent].questions.length - 1;
      // Data[parent].questions.forEach((val, index) => {
      //   if(val.answered === true) question = index;
      // });
    } else {
      question = question - 1;
    }

    if (Data[parent].questions[question].answered) {
      setID(parent);
      setQuesID(question);
    } else {
      PreviousQues(parent, question);
    }
  };

  return (
    <footer className="drop-shadow-2xl border-t-4 border-gray-200 inset-x-0 w-full bg-white">
      <div className="flex flex-row items-center">
        <div className="bg-[#EFEEF5] percentageRatio">
          <p className="text-[#47529B] text-md">
            {percentage ? Math.floor(percentage) : 0}% Complete
          </p>
          <div class="overflow-hidden h-2 mb-2 text-xs flex rounded bg-white">
            <div
              class={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#47529B] ${progress}`}
            ></div>
          </div>
        </div>

        <div className="backBtnWrapper">
          <button
            onClick={handleBack}
            className="rounded-md font-medium flex flex-row"
          >
            <FaArrowLeft className="text-center m-1 ml-0" />
            <p className="text-center ml-1">Back</p>
          </button>
        </div>
        <div className="nextBtnWrapper">
          <button
            onClick={handleNext}
            className="bg-[#DE706C] h-10 rounded-md justify-center text-white font-medium flex flex-row"
          >
            <p className="text-center mr-1">
              {id === 6 && QuesID === 0 ? "Submit" : "Next"}
            </p>
            <FaArrowRight className="text-center m-1 mr-0" />
          </button>
        </div>
      </div>
    </footer>
  );
}
